export default __webpack_public_path__ + "static/Quickinstallation_Lense-Adjust_5905_03-f43dfe5212b512890849f698af909c7e.webp";